import React from "react";
import { Link } from "react-router-dom";
import {
  FaFacebookF,
  FaYoutube,
  FaInstagram,
  FaLinkedinIn,
} from "react-icons/fa";
import { MdOutlineAlternateEmail, MdLocationPin } from "react-icons/md";

function Footer() {
  return (
    <footer className="bg-sky-700/20 text-neutral-800 ">
      <div className="lg:grid lg:grid-cols-2">
        <div className="w-11/12 md:w-1/2 mx-auto lg:w-full lg:flex lg:flex-col lg:items-center lg:justify-center lg:gap-y-5">
          <ul className="links flex flex-row items-center justify-around w-72 mx-auto py-6 space-x-5">
            <Link
              to="https://www.facebook.com/share/qakhtPmDNAzZxBwW/?mibextid=qi2Omg"
              target="_blank"
              className="transition-all w-9 h-9 rounded-lg border-none bg-white text-neutral-700 flex items-center justify-center hover:bg-[#1877F2] hover:text-white">
              <FaFacebookF size={18} />
            </Link>
            <div className="h-1 w-1 bg-neutral-900 border-none rounded-xl"></div>
            <Link
              to="https://www.linkedin.com/company/ieee-cis-uoj/"
              target="_blank"
              className="transition-all w-9 h-9 rounded-lg border-none bg-white text-neutral-700 flex items-center justify-center hover:bg-[#0077B5] hover:text-white">
              <FaLinkedinIn size={20} />
            </Link>
            <div className="h-1 w-1 bg-neutral-900 border-none rounded-xl"></div>
            <Link
              to=""
              target="_blank"
              className="transition-all w-9 h-9 rounded-lg border-none bg-white text-neutral-700 flex items-center justify-center hover:bg-[#FF0000] hover:text-white">
              <FaYoutube size={23} />
            </Link>
            <div className="h-1 w-1 bg-neutral-900 border-none rounded-xl"></div>
            <Link
              to=""
              target="_blank"
              className="transition-all w-9 h-9 rounded-lg border-none bg-white text-neutral-700 flex items-center justify-center hover:bg-instagram-gradient hover:text-white">
              <FaInstagram size={23} />
            </Link>
          </ul>
          <div className="md:flex md:flex-col md:items-start md:justify-evenly gap-y-1">
            <div className="flex items-center justify-between w-11/12 mx-auto mb-2 md:gap-10 md:w-full">
              <div className="flex items-center gap-2">
                <MdOutlineAlternateEmail size={17} />
                <p className="font-bold text-sm md:text-md">E-mail:</p>
              </div>
              <span className="text-right text-xs md:text-left md:text-sm">
                ieeecis@univ.jfn.ac.lk
              </span>
            </div>
            <div className="flex items-start justify-between w-11/12 md:gap-10 mx-auto md:w-full">
              <div className="flex items-center gap-2">
                <MdLocationPin size={17} />
                <p className="font-bold text-sm">Address:</p>
              </div>
              <span className="text-right text-xs font-thin md:text-right md:text-sm">
                Department of Computer Science,
                <br />
                Faculty of Science,
                <br />
                University of Jaffna,
                <br />
                Jaffna,
                <br />
                Sri Lanka
              </span>
            </div>
          </div>
        </div>
        <iframe
          title="csDepartmentLocation"
          className="w-3/4 h-auto m-auto my-8 lg:w-3/4 lg:h-60"
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1966.4735136830504!2d80.01930569839477!3d9.685562500000007!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3afe54125cafe551%3A0x61d1a49bcd146dfe!2zRGVwYXJ0bWVudCBvZiBDb21wdXRlciBTY2llbmNlLCBVbml2ZXJzaXR5IG9mIEphZmZuYS4g4K6V4K6j4K6_4K6p4K6_IOCuheCuseCuv-CuteCuv-Cur-CusuCvjSDgrqTgr4HgrrHgr4gsIOCur-CuvuCutOCvjeCuquCvjeCuquCuvuCuo-CuruCvjSDgrqrgrrLgr43grpXgrrLgr4jgrpXgr43grpXgrrTgrpXgrq7gr40!5e0!3m2!1sen!2sus!4v1684678012881!5m2!1sen!2sus"
          width="600"
          height="450"
          allowfullscreen=""
          loading="lazy"
          referrerpolicy="no-referrer-when-downgrade"></iframe>
      </div>
      <div className="w-full bg-sky-700/70 text-white text-xs font-semibold lg:text-md uppercase">
        <div className="w-11/12 mx-auto flex flex-col items-center justify-center gap-y-2 lg:w-10/12 lg:flex-row lg:items-center lg:justify-between py-1">
          <p className="text-center">
            &copy; CIS, IEEE SB Chapter of UOJ 2023 - All Rights Reserved
          </p>
          <p className="capitalize flex space-x-2 items-center">
            <p>Developed by</p>
            <div className="h-1 w-1 bg-white border-none rounded-xl"></div>
            <a
              href="https://www.linkedin.com/in/chamod-rashmika"
              rel="noreferrer"
              target="_blank"
              className="underline font-bold tracking-wide uppercase">
              Chamod Rashmika
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
